import type { CustomerData } from './types';
import { cloneCustomerData, hasCustomerData } from './types';

/**
 * Store em memória do customer da página.
 * Merge incremental: valores novos não-vazios sobrescrevem.
 */
export class CustomerIdentityService {
  private snapshot: CustomerData = {};

  update(partial: CustomerData): void {
    const next: CustomerData = { ...this.snapshot };

    for (const [key, value] of Object.entries(partial) as Array<
      [keyof CustomerData, string | undefined]
    >) {
      if (typeof value !== 'string') continue;
      const trimmed = value.trim();
      if (!trimmed) continue;
      next[key] = trimmed;
    }

    if (!next.name && next.firstName) {
      next.name = [next.firstName, next.lastName].filter(Boolean).join(' ');
    }

    this.snapshot = next;
  }

  getSnapshot(): CustomerData | null {
    if (!hasCustomerData(this.snapshot)) return null;
    return cloneCustomerData(this.snapshot);
  }

  clear(): void {
    this.snapshot = {};
  }
}
